import { FilterRarityType } from "../hooks/AssetSettingModalType";
import AssetRarityButton from "./AssetRarityButton";

type Props = {
    selectedRarity: FilterRarityType;
    onSelectStateFilterRarity: (selectedRarity: FilterRarityType) => void,
}

const AssetRarityButtonGroup = ({ selectedRarity, onSelectStateFilterRarity }: Props) => {
    return (
        <>
            <AssetRarityButton
                rarity={"Legendary"}
                selectedRarity={selectedRarity}
                onSelectStateFilterRarity={onSelectStateFilterRarity}
            />
            <AssetRarityButton
                rarity={"Epic"}
                selectedRarity={selectedRarity}
                onSelectStateFilterRarity={onSelectStateFilterRarity}
            />
            <AssetRarityButton
                rarity={"Rare"}
                selectedRarity={selectedRarity}
                onSelectStateFilterRarity={onSelectStateFilterRarity}
            />
            <AssetRarityButton
                rarity={"Uncommon"}
                selectedRarity={selectedRarity}
                onSelectStateFilterRarity={onSelectStateFilterRarity}
            />
            <AssetRarityButton
                rarity={"Common"}
                selectedRarity={selectedRarity}
                onSelectStateFilterRarity={onSelectStateFilterRarity}
            />
        </>
    );
}

export default AssetRarityButtonGroup;